import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AccountUpdatePage } from './account-update';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from '../../pipes/pipes.module';
import {IonTagsInputModule} from "ionic-tags-input";

@NgModule({
  declarations: [
    AccountUpdatePage,
  ],
  imports: [
    DirectivesModule,
    PipesModule,
    IonTagsInputModule,
    IonicPageModule.forChild(AccountUpdatePage),
  ],
})
export class AccountUpdatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/account-update/account-update.module.ts